import React from "react";
import TeachersTable from "../components/tables/TeachersTable";
import TeacherForm from "../components/forms/TeacherForm";

const Teachers: React.FC = () => {
  return (
    <div className="p-6 min-h-screen bg-gradient-to-br from-gray-50 to-indigo-50/30">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Teachers</h1>
        <p className="text-gray-600">
          Manage teaching staff and their information
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-1">
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-2xl border-0">
            <h2 className="text-xl font-semibold mb-4 text-gray-800">
              Add New Teacher
            </h2>
            <TeacherForm
              onSuccess={() => {
                // TODO: Handle success callback
                console.log("Teacher saved successfully");
              }}
            />
          </div>
        </div>

        <div className="lg:col-span-2">
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-1 shadow-2xl">
            <TeachersTable />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Teachers;
